import { ResourceType } from 'enums/videoType';

export const getVideoUrl = (video: any, config: any) => {
 if (video.actionType === ResourceType.Regular && video.file) return config.filesBaseUrl + config.filesBasePath + '/' + video.file.fileName;

 if (video.actionType === ResourceType.Embeded && video.videoUrl) return video.videoUrl;

 return null;
};
